module.exports = __webpack_public_path__ + "img/bg-ai-stars-mobile.f22923e.png";